import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { AiOutlineArrowDown } from "react-icons/ai";
import { BsInfoCircle } from "react-icons/bs";
import { FaGasPump } from "react-icons/fa";
import { TiCogOutline } from "react-icons/ti";
import img1 from "../../assets/images/country/art.png";
import img2 from "../../assets/images/country/usdt.png";
import Button from "../Buttons/Button";
import "./Calculation.sass";
import CountrySelector from "./CountrySelector";
const Calculation = () => {
	const [first__value, setFirstValue] = useState("1.00");
	const [last__value, setLastValue] = useState("20.00");

	return (
		<section className="calculation-section">
			<Container>
				<form className="calculation-warpper">
					<div className="calculation-header">
						<h5 className="title d-flex justify-content-between align-items-center">
							<span>AFRIARTS PRESALE</span>
							<button type="button" className="cog-button">
								<TiCogOutline />
							</button>
						</h5>
					</div>
					<div className="select-item border">
						<div className="select-group">
							<input
								className="form-control"
								type="number"
								value={`${first__value}`}
								onChange={(e) => setFirstValue(e.target.value)}
							/>
							<CountrySelector img={img1} name="USDT" />
						</div>
						<div className="d-flex align-items-center justify-content-between">
							<span>$1.00</span>
							<div>
								<span className="me-2">Balance: 0.01276</span>
								<span className="badge">MAX</span>
							</div>
						</div>
						<button type="button" className="arrow-button">
							<AiOutlineArrowDown />
						</button>
					</div>
					<div className="select-item">
						<div className="select-group">
							<input
								className="form-control"
								type="number"
								value={`${last__value}`}
								onChange={(e) => setLastValue(e.target.value)}
							/>
							<CountrySelector img={img2} name="ART" />
						</div>
						<div className="d-flex align-items-center justify-content-between">
							<span>$1.00</span>
							<span className="me-2">ART Purchased : 0</span>
						</div>
					</div>
					<div className="py-3 d-flex justify-content-between">
						<div>
							<span className="me-1">
								<BsInfoCircle />
							</span>
							<span className="text-white">1 USDT = 20 ART ($1)</span>
						</div>
						<div>
							<span className="me-1">
								<FaGasPump />
							</span>
							<select className="header-select">
								<option>5 gwei</option>
								<option>2 gwei</option>
								<option>3 gwei</option>
							</select>
						</div>
					</div>
					<Button
						text="Buy Art"
						classes={`btn--base w-100 subscribeButton text-dark`}
						type="submit"
					/>
				</form>
			</Container>
		</section>
	);
};

export default Calculation;
